import type { BestRecord } from '../game/state';

/** 本地最佳记录与时间格式化（纯逻辑 + localStorage，可单测）。 */

const PREFIX = 'pintu:best:';

export function bestRecordKey(
  imageKey: string,
  difficulty: string,
  rotateMode: boolean,
): string {
  return `${PREFIX}${imageKey}|${difficulty}|${rotateMode ? 'rot' : 'flat'}`;
}

/** 读取最佳记录；localStorage 不可用时返回 null（绝不抛错）。 */
export function loadBest(key: string): BestRecord | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<BestRecord>;
    if (
      typeof parsed.timeMs === 'number' &&
      typeof parsed.moves === 'number' &&
      Number.isFinite(parsed.timeMs) &&
      Number.isFinite(parsed.moves)
    ) {
      return { timeMs: parsed.timeMs, moves: parsed.moves };
    }
    return null;
  } catch {
    return null;
  }
}

/** 写入最佳记录；localStorage 不可用时静默忽略。 */
export function saveBest(key: string, record: BestRecord): void {
  try {
    localStorage.setItem(key, JSON.stringify(record));
  } catch {
    /* 配额不足 / 隐私模式：忽略 */
  }
}

/** 候选是否优于既有（先比时长，再比步数）。 */
export function isBetter(prev: BestRecord | null, cand: BestRecord): boolean {
  if (!prev) return true;
  if (cand.timeMs !== prev.timeMs) return cand.timeMs < prev.timeMs;
  return cand.moves < prev.moves;
}

/** 毫秒 → mm:ss(.s)。 */
export function formatTime(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) ms = 0;
  const totalSec = ms / 1000;
  const m = Math.floor(totalSec / 60);
  const s = Math.floor(totalSec % 60);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(m)}:${pad(s)}`;
}
